import {makeReplaceName} from '@shared/helpers/format'

import {isAlphaProfile, isBetaProfile, isDevProfile, isRealProfile} from '@web/core/config'
import {
    ROUTER_ORDER_RESULT,
    ROUTER_ORDER_APPLY,
    ROUTER_ORDER_CHECK_OUT,
    ROUTER_ORDER_DETAIL,
    ROUTER_ORDER_SALE_HISTORY,
    ROUTER_ORDER_SALE_SETTLEMENT,
    ROUTER_ORDER_PURCHASE_CONFIRMATIONS,
    ROUTER_ORDER_SHEET,
    ROUTER_ORDER_SHEET_SELLER,
    ROUTER_ORDER_SHEET_FAMILY_PAY,
    ROUTER_ORDER_SHEET_SUBSCRIPTION,
} from '@web/core/routes'
import {Sentry} from '@web/helpers/log'

const pathname = window.location.pathname
const orderSheetId = '[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}'
// const orderProcessId = '[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}'
const orderNo = '[0-9]+'
const productOrderNo = '[0-9]{16}'
const subscriptionSequenceId = '([a-zA-Z0-9-]+)'

/**
 * 주문형앱(ordersheet) Sentry 초기화 수행
 */
const initialize = () => {
    if (Sentry.isDevMode || isDevProfile || isAlphaProfile || isBetaProfile || isRealProfile) {
        Sentry.initialize({
            transactionName: (function () {
                const result = pathname
                    // c1/3
                    .replace(new RegExp(`${ROUTER_ORDER_CHECK_OUT.MALL}/${orderSheetId}`, 'g'), 'C1 주문서 페이지 조회')
                    .replace(
                        new RegExp(`${ROUTER_ORDER_CHECK_OUT.EASY_BOOKING}/${orderSheetId}`, 'g'),
                        '예약 주문서 페이지 조회',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_CHECK_OUT.LOCAL_PAY}/${orderSheetId}`, 'g'),
                        '로컬페이 주문서 페이지 조회',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_CHECK_OUT.BLOG}/${orderSheetId}`, 'g'),
                        '블로그 주문서 페이지 조회',
                    )
                    //
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET.MALL.CHECK_OUT}/${orderSheetId}`, 'g'),
                        'C1 주문서 페이지 조회',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET.EASY_BOOKING.CHECK_OUT}/${orderSheetId}`, 'g'),
                        '예약 주문서 페이지 조회',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET.LOCAL_PAY.CHECK_OUT}/${orderSheetId}`, 'g'),
                        '로컬페이 주문서 페이지 조회',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET.BLOG.CHECK_OUT}/${orderSheetId}`, 'g'),
                        '블로그 주문서 페이지 조회',
                    )
                    .replace(
                        /\/order\/bridge\/mall\/[a-zA-Z0-9]{22}\/[0-9]{9}/g,
                        '/order/bridge/mall/{registerOrderKey}/{merchantNo}',
                    )
                    .replace(new RegExp(`${ROUTER_ORDER_RESULT.MALL}/${orderNo}`, 'g'), 'C1 주문결과 조회')
                    .replace(new RegExp(`${ROUTER_ORDER_RESULT.EASY_BOOKING}/${orderNo}`, 'g'), '예약 주문결과 조회')
                    .replace(new RegExp(`${ROUTER_ORDER_RESULT.LOCAL_PAY}/${orderNo}`, 'g'), '로컬페이 주문결과 조회')
                    .replace(new RegExp(`${ROUTER_ORDER_RESULT.BLOG}/${orderNo}`, 'g'), '블로그 주문결과 조회')
                    .replace(new RegExp(`${ROUTER_ORDER_APPLY.MALL}/${orderNo}`, 'g'), 'C1 주문승인')
                    .replace(new RegExp(`${ROUTER_ORDER_APPLY.EASY_BOOKING}/${orderNo}`, 'g'), '예약 주문승인')
                    .replace(new RegExp(`${ROUTER_ORDER_APPLY.LOCAL_PAY}/${orderNo}`, 'g'), '로컬페이 주문승인')
                    .replace(new RegExp(`${ROUTER_ORDER_APPLY.BLOG}/${orderNo}`, 'g'), '블로그 주문승인')
                    // c2
                    .replace(new RegExp(`${ROUTER_ORDER_SHEET_SELLER.CHECKOUT}/${orderSheetId}`, 'g'), 'C2 주문서 조회')
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET_SELLER.CHECKOUT_APPLY.SHOPN}/${orderNo}`, 'g'),
                        'C2 즉시결제 주문승인',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET_SELLER.CHECKOUT_APPLY.GIFTING}/${orderNo}`, 'g'),
                        'C2 선물하기 주문승인',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET_SELLER.CHECKOUT_APPLY.BRANCH}/${orderNo}`, 'g'),
                        'C2 장보기 주문승인',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET_SELLER.CHECKOUT_FAIL.SHOPN}/${orderNo}`, 'g'),
                        'C2 즉시결제 주문실패',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET_SELLER.CHECKOUT_FAIL.GIFTING}/${orderNo}`, 'g'),
                        'C2 선물하기 주문실패',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET_SELLER.CHECKOUT_FAIL.BRANCH}/${orderNo}`, 'g'),
                        'C2 장보기 주문실패',
                    )
                    .replace(new RegExp(`${ROUTER_ORDER_SHEET_SELLER.RESULT}/${orderNo}`, 'g'), 'C2 주문결과 조회')
                    .replace(new RegExp('/ordersheet/seller/firstDelivery/search/' + orderSheetId, 'g'), '배송지 검색')
                    .replace(new RegExp('/ordersheet/seller/firstDelivery/form/' + orderSheetId, 'g'), '배송지 입력')
                    // 패밀리결제
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET_FAMILY_PAY.CHECKOUT}/${orderNo}`, 'g'),
                        '패밀리결제 주문서 조회',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET_FAMILY_PAY.APPLY}/${orderSheetId}`, 'g'),
                        '패밀리결제 주문승인',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET_FAMILY_PAY.FAIL}/${orderSheetId}`, 'g'),
                        '패밀리결제 주문실패',
                    )
                    .replace(
                        new RegExp(`${ROUTER_ORDER_SHEET_FAMILY_PAY.RESULT}/${orderNo}`, 'g'),
                        '패밀리결제 주문 결과 조회',
                    )
                    // 주문상세
                    .replace(new RegExp(`${ROUTER_ORDER_DETAIL.ROOT}/[0-9]+`, 'g'), `주문상세`)
                    // 구매확정
                    .replace(new RegExp(`${ROUTER_ORDER_PURCHASE_CONFIRMATIONS.ROOT}/${orderNo}`, 'g'), '구매확정')
                    .replace(
                        new RegExp(`${ROUTER_ORDER_PURCHASE_CONFIRMATIONS.RESULT}/${orderNo}`, 'g'),
                        '구매확정결과',
                    )
                return makeReplaceName([
                    // 정기구독
                    [
                        `${ROUTER_ORDER_SHEET_SUBSCRIPTION.ROOT}/${subscriptionSequenceId}/subscription`,
                        '정기구독 신청서 조회',
                    ],
                    [`${ROUTER_ORDER_SHEET_SUBSCRIPTION.ROOT}/${subscriptionSequenceId}/apply`, '정기구독 신청'],
                    [`${ROUTER_ORDER_SHEET_SUBSCRIPTION.ROOT}/${subscriptionSequenceId}/fail`, '정기구독 신청실패'],
                    [`${ROUTER_ORDER_SHEET_SUBSCRIPTION.ROOT}/${subscriptionSequenceId}/result`, '정기구독 신청결과'],
                    [
                        `${ROUTER_ORDER_SHEET_SUBSCRIPTION.ROOT}/${subscriptionSequenceId}/bridge/fds`,
                        '정기구독 FDS 브릿지',
                    ],
                    // 판매 내역, 상세 > 과업
                    [
                        `${ROUTER_ORDER_SALE_HISTORY.CANCEL_REJECT}/${orderNo}/product/${productOrderNo}`,
                        '판매내역 취소거부',
                    ],
                    [
                        `${ROUTER_ORDER_SALE_HISTORY.CANCEL_SALE}/${orderNo}/product/${productOrderNo}`,
                        '판매내역 취소거부',
                    ],
                    [
                        `${ROUTER_ORDER_SALE_HISTORY.DELIVERY_DISPATCH}/${orderNo}/product/${productOrderNo}`,
                        '판매내역 발송처리',
                    ],
                    [
                        `${ROUTER_ORDER_SALE_HISTORY.RETURN_ADMISSION}/${orderNo}/product/${productOrderNo}`,
                        '판매내역 반품승인',
                    ],
                    [
                        `${ROUTER_ORDER_SALE_HISTORY.RETURN_REJECT}/${orderNo}/product/${productOrderNo}`,
                        '판매내역 반품거절',
                    ],
                    [`${ROUTER_ORDER_SALE_HISTORY.DETAIL}/${orderNo}`, '판매내역 상세'],
                    [`${ROUTER_ORDER_SALE_HISTORY.SEARCH}`, '판매내역 검색'],
                    // 정산 상세
                    [`${ROUTER_ORDER_SALE_SETTLEMENT.SEARCH}`, '정산내역 검색'],
                    [`${ROUTER_ORDER_SALE_SETTLEMENT.PAY_HOLD}`, '정산내역 지급보류'],
                    [`${ROUTER_ORDER_SALE_SETTLEMENT.DETAIL}/${orderNo}`, '정산내역 상세'],
                ])(result)
            })(),
            normalizeDepth: 10,
            tags: {app: 'ordersheet'},
        })
    }
}

export default initialize
